<div class="ac-dropdown">
	<select (change)="selectSize($event.target.value)">
		<option *ngFor="let size of pageSizeChoices" [value]="size" [selected]="size === pageSize">Show {{ size }} rows</option>
	</select>
</div>
<ul class="pagination">
	<li class="page-item" [class.disabled]="previousDisabled()">
		<a class="page-link" href (click)="selectPage(page - 1); $event.preventDefault()" [attr.tabindex]="hasPrevious() ? null : '-1'"> <span>&laquo;</span> </a>
	</li>
	<li *ngFor="let pageNumber of pages" class="page-item">
		<a class="page-link" href (click)="selectPage(pageNumber); $event.preventDefault()" [class.active]="pageNumber === page"> {{ pageNumber }}</a>
	</li>
	<li class="page-item" [class.disabled]="nextDisabled()">
		<a class="page-link" href (click)="selectPage(page + 1); $event.preventDefault()" [attr.tabindex]="hasNext() ? null : '-1'"> <span>&raquo;</span> </a>
	</li>
</ul>
